import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ModelUpload.css';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

function ModelUpload() {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: '',
    version: '1.0',
    client: '',
    classes_count: '1423',
    input_size: '1280',
  });
  
  const [onnxFile, setOnnxFile] = useState(null);
  const [ptFile, setPtFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('');
  
  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
  
  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setStatus('');
    
    if (!formData.name || !formData.client || !onnxFile) {
      setError('Please fill in all required fields');
      return;
    }
    
    setUploading(true);
    setStatus('📤 Uploading model...');
    
    try {
      const form = new FormData();
      form.append('name', formData.name);
      form.append('version', formData.version);
      form.append('client', formData.client);
      form.append('classes_count', formData.classes_count);
      form.append('input_size', formData.input_size);
      form.append('onnx_file', onnxFile);
      if (ptFile) form.append('pt_file', ptFile);
      
      const res = await fetch(`${API_URL}/api/models/upload`, {
        method: 'POST',
        body: form,
      });
      
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Upload failed');
      }
      
      const data = await res.json();
      setStatus('✅ Model uploaded successfully!');
      
      setTimeout(() => {
        navigate('/');
      }, 1500);
    } catch (err) {
      setError(err.message);
      setStatus('');
    } finally {
      setUploading(false);
    }
  }
  
  return (
    <div className="model-upload-page">
      <h1>📤 Upload Model</h1>
      
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label>Model Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="e.g., yolo11-products"
            required
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Version *</label>
            <input
              type="text"
              name="version"
              value={formData.version}
              onChange={handleChange}
              placeholder="e.g., 1.0"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Client *</label>
            <input
              type="text"
              name="client"
              value={formData.client}
              onChange={handleChange}
              placeholder="e.g., ClientName"
              required
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Classes Count</label>
            <input
              type="number"
              name="classes_count"
              value={formData.classes_count}
              onChange={handleChange}
              min="1"
            />
          </div>
          
          <div className="form-group">
            <label>Input Size</label>
            <select
              name="input_size"
              value={formData.input_size}
              onChange={handleChange}
            >
              <option value="640">640</option>
              <option value="1280">1280</option>
              <option value="1920">1920</option>
            </select>
          </div>
        </div>
        
        <div className="form-group">
          <label>ONNX Model File *</label>
          <input
            type="file"
            accept=".onnx"
            onChange={(e) => setOnnxFile(e.target.files?.[0])}
            required
          />
          {onnxFile && (
            <div className="file-info">
              ✅ {onnxFile.name} ({(onnxFile.size / 1024 / 1024).toFixed(2)} MB)
            </div>
          )}
        </div>
        
        <div className="form-group">
          <label>Original Model File (PT) - Optional</label>
          <input
            type="file"
            accept=".pt,.pth"
            onChange={(e) => setPtFile(e.target.files?.[0])}
          />
          {ptFile && (
            <div className="file-info">
              ✅ {ptFile.name} ({(ptFile.size / 1024 / 1024).toFixed(2)} MB)
            </div>
          )}
        </div>
        
        {error && <div className="error-message">❌ {error}</div>}
        {status && <div className="status-message">{status}</div>}
        
        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/')}
            disabled={uploading}
          >
            Cancel
          </button>
          
          <button
            type="submit"
            className="btn-primary"
            disabled={uploading}
          >
            {uploading ? '⏳ Uploading...' : '📤 Upload Model'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ModelUpload;

